// src/components/MovieGrid.jsx
import React from "react";
import "./MovieGrid.css";
import MovieCard from "../MovieCard/MovieCard";
import ApiError from "../ApiError/ApiError";
import NoResults from "../NoResults/NoResults";
import Loading from "../loading/loading";

export default function MovieGrid({
                                      movies = [],
                                      page = 1,
                                      totalPages = 1,
                                      onPageChange = () => {},
                                      onCardClick = () => {},
                                      loading = false,
                                      error = "",
                                  }) {
    const goTo = (p) => onPageChange(Math.min(Math.max(1, p), totalPages>500?500:totalPages));

    if (loading) return <Loading label="Loading movies…" />;
    if (error) return <ApiError message={error} />;
    if (!movies?.length) return <NoResults />;

    return (
        <section className="moviegrid">
            <div className="moviegrid__list">
                {movies.map((m) => (
                    <MovieCard key={m.id} movie={m} onOpen={() => onCardClick(m)} />
                ))}
            </div>

            {totalPages > 1 && (
                <nav className="moviegrid__pagination" aria-label="Pagination">
                    <button className="button" onClick={() => goTo(1)} disabled={page === 1}>«</button>
                    <button className="button" onClick={() => goTo(page - 1)} disabled={page === 1}>‹</button>
                    <span className="meta">Page {page} of {totalPages>500?500:totalPages}</span>
                    <button className="button" onClick={() => goTo(page + 1)} disabled={page === totalPages}>›</button>
                    <button className="button" onClick={() => goTo(totalPages)} disabled={page === totalPages}>»</button>
                </nav>
            )}
        </section>
    );
}
